import React from 'react';
import TrustpilotStars from 'components/common/TrustpilotStars';
import PaddingBox from '@uds/padding-box';
import { BodyCopy, Heading04 } from '@uds/typography';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';

import getClassNames from './Review.stylesheet';

export interface ReviewProps {
  stars: string;
  byline: string;
  excerpt: ShortcodeProps;
}

interface OuterProps extends ReviewProps {}

export const AdvocateReview = ({ stars, excerpt, byline }: OuterProps) => {
  const classNames = getClassNames();
  return (
    <PaddingBox className={classNames.root}>
      <div className={classNames.stars}>
        <TrustpilotStars rating={stars} />
      </div>
      <blockquote className={classNames.textContainer}>
        <Heading04 component="cite" className={classNames.excerpt}>
          <Shortcode code={excerpt} />
        </Heading04>
        <BodyCopy>{byline}</BodyCopy>
      </blockquote>
    </PaddingBox>
  );
};

AdvocateReview.displayName = 'AdvocateReview';

export default AdvocateReview;
